export enum DocumentStatusEnum {
    Current = 1,
    Archived = 2,
    Expired = 3,
    Rescinded = 4,
    Deleted = 5,
    DeletedFull = 6
}
